module.exports = __webpack_public_path__ + "img/gb-wls.gb-wls4abd7bc.svg";